export const TRACKING_CATEGORY = {
  USER_CLICK_ACTION: "BFF: User click action",
};
